/**
 * External dependencies
 */
import { useCallback } from 'react';

/**
 * Internal dependencies
 */
import useReduxApi from '@naruto/bgdapp/src/hooks/useReduxApi';
import useMappedState from '@naruto/bgdapp/src/hooks/useMappedState';

export const DRAWER_WIDTH = 208;
export const DRAWER_TOP = 60;

interface UseData {
  /* Data : General */
  isGlobalSidebarOpen: boolean;
  /* Functions: General */
  toggleDrawer: () => void;
}

function useData(): UseData {
  /* Global & Local State */
  const reduxGlobal = useReduxApi('global');
  const storeGlobal = useMappedState(state => state.global);

  /* Functions : General */
  const toggleDrawer = useCallback((): void => {
    reduxGlobal('postGlobalSideBar', [!storeGlobal.globalSideBar]);
  }, [storeGlobal.globalSideBar]);

  /* Main */
  return {
    /* Data : General */
    isGlobalSidebarOpen: storeGlobal.globalSideBar,
    /* Functions : General */
    toggleDrawer
  };
}

export default useData;
